<div class="main_content px-3 position-relative">
  <div class="container-fluid py-3">
    <div class="title mb-4">
      <h4>Google Reviews</h4>
    </div>

    <div class="row">
      <div class="col-lg-8 col-md-12">
        <h5 class="dash_subheading">VIP tokens</h5>
        <div class="white_box shadow p-3">
          <div class="purchase_div">
            <div class="job_plan mb-4 mt-4">
              <div class="row">
                <div class="col-xl-4 col-lg-6 col-md-12 mb-4">
                  <div class="card pt-3 text-center">
                    <h3>5 Reviews</h3>

                    <div class="doller_icon mx-auto d-flex align-items-center justify-content-center">
                      <img loading="lazy" src="../../../assets/images/new/google_iocn.png" alt="" />
                    </div>
                    <p class="snatcoin">10 VIP tokens</p>
                    <!-- <p class="setprice">$ 99</p> -->

                    <span class="save_info bg-transparent"> </span>

                    <a class="yellow_btn mx-auto my-3 yellow_btn_ded" (click)="deduct_credits('10','5')">Deduct
                      Credits</a>
                  </div>
                </div>
                <div class="col-xl-4 col-lg-6 col-md-12 mb-4">
                  <div class="card pt-3 text-center">
                    <h3>10 Reviews</h3>

                    <div class="doller_icon mx-auto d-flex align-items-center justify-content-center">
                      <img loading="lazy" src="../../../assets/images/new/google_iocn.png" alt="" />
                    </div>
                    <p class="snatcoin">20 VIP tokens</p>
                    <!-- <p class="setprice">$ 199</p> -->

                    <span class="save_info"> +1 Free </span>

                    <a class="yellow_btn mx-auto my-3 yellow_btn_ded" (click)="deduct_credits('20','10')">Deduct
                      Credits</a>
                  </div>
                </div>
                <div class="col-xl-4 col-lg-6 col-md-12 mb-4">
                  <div class="card pt-3 text-center">
                    <h3>15 Reviews</h3>

                    <div class="doller_icon mx-auto d-flex align-items-center justify-content-center">
                      <img loading="lazy" src="../../../assets/images/new/google_iocn.png" alt="" />
                    </div>
                    <p class="snatcoin">30 VIP tokens</p>
                    <!-- <p class="setprice">$ 299</p> -->

                    <span class="save_info"> +2 Free </span>

                    <a class="yellow_btn mx-auto my-3 yellow_btn_ded" (click)="deduct_credits('30','15')">Deduct
                      Credits</a>
                  </div>
                </div>
                <div class="col-xl-4 col-lg-6 col-md-12">
                  <div class="card pt-3 text-center">
                    <h3>20 Reviews</h3>

                    <div class="doller_icon mx-auto d-flex align-items-center justify-content-center">
                      <img loading="lazy" src="../../../assets/images/new/google_iocn.png" alt="" />
                    </div>
                    <p class="snatcoin">40 VIP tokens</p>
                    <!-- <p class="setprice">$ 499</p> -->

                    <span class="save_info"> +3 Free </span>

                    <a class="yellow_btn mx-auto my-3 yellow_btn_ded" (click)="deduct_credits('40','20')">Deduct
                      Credits</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-12">
        <h5 class="dash_subheading">Available VIP tokens</h5>
        <div class="white_box">
          <div class="card_title">
            <p>Available VIP tokens</p>
          </div>
          <div class="icon_count">
            {{ total_txn }} <i class="fa-solid pl-2 fa-bars"></i>
          </div>
          <div class="right_side_text">
            <p (click)="view_all_transactions(view_all_transactions_popup)">
              View all transactions
            </p>
          </div>
        </div>

        <!-- <h5 class="dash_subheading my-4 ">Bonus VIP tokens</h5>

<div class="white_box ">
    <div class="card_title">
        <p>Available VIP tokens</p>
    </div>
    <div class="icon_count">
        0 <i class="fa-regular fa-star"></i>
    </div>
    <div class="right_side_text">
        <p>View all transactions</p>
    </div>
</div> -->

        <h5 class="dash_subheading mt-4 ">Description</h5>

        <div class="white_box ">
          <div class="card_list">
            <ul class="">
              <li><i class="fa-solid fa-circle-check pr-3 cg"></i>Drip feed over time to ensure natural</li>
              <li>
                <i class="fa-solid fa-circle-check pr-3 cg"></i>SERP optimized for higher Google Ranking
              </li>
              <li><i class="fa-solid fa-circle-check pr-3 cg"></i>Dedicated Account Manager</li>
              <li>
                <i class="fa-solid fa-circle-check pr-3 cg"></i>3 Month Free Replacement
              </li>
            </ul>

          </div>
        </div>

        <h5 class="dash_subheading mt-4 ">Additional Info</h5>

        <div class="white_box ">
          <div class="card_title mb-2">
            <p>Details</p>
          </div>
          <div class="card_list">
            <ul class="">
              <li><i class="fa-solid fa-circle-check pr-3"></i>Top Up Credits for VIP token deductions</li>
              <li>
                <i class="fa-solid fa-circle-check pr-3"></i>Please check details before deductions
              </li>
              <li><i class="fa-solid fa-circle-check pr-3"></i>Deductions are non-refundable</li>
              <li>
                <i class="fa-solid fa-circle-check pr-3"></i>MYVIP has the right to change any terms without prior
                communication

              </li>
            </ul>

          </div>
        </div>


      </div>
    </div>

    <br />

    <div class="row">
      <div class="col-lg-12 col-md-12">
        <!-- <h5 class="dash_subheading ">Google Reviews</h5> -->

        <!-- <button class="btn btn-secondary add_goo_rev" (click)="open_google_review_modal()">Add Reviews</button> -->

        <!-- <button class="btn btn-outline-primary mb-2 me-2" (click)="openBackDropCustomClass(content)">
add review
</button> -->
        <!-- <p>{{google_feedbacks|json}}</p> -->


        <div class="goo_bg">
          <table class="table">
            <thead class="thead-dark">
              <tr>
                <th scope="col">S.No.</th>
                <th scope="col">Name</th>
                <th scope="col">Review</th>
                <th scope="col">Stars</th>
                <th scope="col">Date</th>
                <th scope="col">Action</th>
              </tr>
            </thead>


            <tbody>
              <tr *ngFor="let feedback of google_feedbacks; let i = index">
                <th scope="row">{{ googlecoundata-i }}</th>
                <td>
                  {{ feedback.feedbackNameurl }}
                  <!-- {{ feedback.feedback_name.feedbackNameurl }} -->
                </td>
                <td>{{ feedback.description?.substring(0, 20) }}</td>
                <td class="ngb_rate_td">
                  <p class="ngb_rate">
                    <ngb-rating [(rate)]="feedback.star" [max]="5" [readonly]="true" class="gift"></ngb-rating>
                  </p>
                </td>
                <td>{{ feedback.created * 1000 | date : "medium" }}</td>
                <td>
                  <a (click)="editReview(content, feedback.id,feedback)" class="btn btn-info">
                    <i class="fas fa-edit"></i></a>
                  &nbsp;
                  <a *ngIf="feedback.is_verify == 0" class="btn btn-danger">Pending</a>
                  <a (click)="viewlimage(view,feedback.id)" *ngIf="feedback.is_verify == 1"
                    class="btn btn-success">Completed</a>
                  <!-- <a  *ngIf="feedback.is_verify==0" ><i class='fa-solid fa-circle' style='color: red'></i></a>
                  <a   *ngIf="feedback.is_verify==1" ><i class='fa-solid fa-circle' style='color: green'></i></a> -->
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #content let-modal class="edite_modle">
  <div class="edite_modle">
    <div class="modal-header justify-content-center">
      <h4 class="modal-title">Edit Review</h4>
      <!-- <h3 class="text-center">Edit Review</h3> -->

      <a class="btn-close ml-auto" (click)="modal.dismiss('Cross click')">x</a>
      <!-- <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button> -->
    </div>
    <form action="">
      <div class="modal-body">
        <form [formGroup]="editFG">
          <div class="form-group">
            <select class="form-control" formControlName="feedbackNameurl" (change)="onChange($event.target.value)">
              <!-- <option  [selected]  >Select name</option> -->
              <option *ngFor="let url of url_names" value="{{ url.url_name}}">
                {{ url.url_name }}
              </option>
            </select>
            <br />


            <select name="" id="" class="form-control" formControlName="feedbackName"
              (change)="subonChange($event.target.value)">
              <option *ngFor="let feedbackname of get_all_feedback_URL"
                selected="{{feedbackname?.description==edit_google_feedbacks.description?feedbackname?.description:''}}"
                value="{{feedbackname?.description}}">
                {{feedbackname?.description}}
              </option>
            </select>
            <br />


            <textarea class="form-control" placeholder="Write feedback"
              formControlName="description">{{ edit_google_feedbacks.description }}</textarea>

            <div class="feedback_rating float-none pt-0">
              <p>
                <ngb-rating [(rate)]="edit_google_feedbacks.star" formControlName="star" max="5"
                  class="gift"></ngb-rating>
              </p>
            </div>
          </div>
          <div class="text-center">
            <button class="btn btn-primary mx-auto" (click)="update_edit_google_feedbacks()">
              Update
            </button>
          </div>
        </form>
      </div>
    </form>
  </div>
</ng-template>

<!-- <ng-template #view_all_transactions_popup let-modal>
  <button type="button" class="close close_modal" style="outline: none;" (click)="modal.dismiss('Cross click')"
      data-dismiss="modal"><span aria-hidden="true">×</span></button>

  <div class="modal-header">
      <h5 class="modal_title">VIP Tokens Deduction Report</h5>
  </div>
  <div class="modal-body p-4">
      <div class="row">
          <div class="col-md-12">
              <table class="table">
                  <thead class="thead-light">
                      <tr>
                          <th scope="col">Sr.No.</th>
                          <th scope="col">Detail</th>
                          <th scope="col">VIP Tokens</th>
                          <th scope="col">Ded. Status</th>
                          <th scope="col">Date</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr *ngFor="let i of transactions; let a = index">
                          <th scope="row">{{ a + 1 }}</th>
                          <td>Deduct VIP Token</td>
                          <td>{{ i.tokens }}</td>
                          <td>completed</td>
                          <td>{{ i.created * 1000 | date:'medium' }}</td>
                      </tr>
                  </tbody>
              </table>
          </div>
      </div>
  </div>
</ng-template> -->

<ng-template #view_all_transactions_popup let-modal>
  <button type="button" class="close close_modal" style="outline: none" (click)="modal.dismiss('Cross click')"
    data-dismiss="modal">
    <span aria-hidden="true">×</span>
  </button>

  <div class="modal-header">
    <h5 class="modal_title">VIP Tokens Report</h5>
  </div>
  <div class="modal-body p-4">
    <div class="row">
      <div class="col-md-12 add_ded_tbl">
        <table class="table">
          <thead class="thead-light">
            <tr>
              <th scope="col">Sr.No.</th>
              <th scope="col">Detail</th>
              <th scope="col">VIP Tokens</th>
              <th scope="col">Txn. Status</th>
              <th scope="col">Ded. From</th>
              <th scope="col">Date</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let i of transactions; let a = index">
              <th scope="row">{{ a + 1 }}</th>
              <td>
                <span *ngIf="i.add_deduct == 'add'">Add VIP Token</span>
                <span *ngIf="i.add_deduct == 'deduct'">Deduct VIP Token</span>
              </td>
              <td>{{ i.tokens }}</td>
              <td>
                <span *ngIf="i.add_deduct == 'add'">{{ i.status }}</span>
                <span *ngIf="i.add_deduct == 'deduct'">complete</span>
              </td>
              <td>
                <span *ngIf="i.type == 0"><i class="fas fa-coins"></i></span>
                <span *ngIf="i.type == 1"><i class="fab fa-google"></i></span>
                <span *ngIf="i.type == 2"><i class="fab fa-instagram"></i></span>
                <span *ngIf="i.type == 3"><i class="fab fa-twitter"></i></span>
                <span *ngIf="i.type == 4"> GM {{i.show}} </span>
                <span *ngIf="i.type == 5"> ST {{i.show}} </span>
                <span *ngIf="i.type == 6"> {{i.show}} </span>
              </td>
              <td>{{ i.created * 1000 | date : "medium" }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #view let-modal>
  <div class="modal-header">
    <h4 class="modal-title">View image </h4>
    <a (click)="modal.dismiss('Cross click')"><i class="fa fa-window-close" aria-hidden="true"></i></a>
  </div>
  <div class="modal-body text-center">

    <img loading="lazy" src="{{imgUrl}}{{imagepreview}}" class="modal_sm_img" alt="">

    <!-- <input
        type="file"
        name=""
        id=""
        class="form-control"
        accept="image/*"
        (change)="onFileChanged($event)"
      />
      <br /> -->
    <!-- <select name="" id="" class="form-control" formControlName="subadminid">
        <option *ngFor="let name of subAdmainName" value="{{ name.id }}">
          {{ name.userName }}
        </option>
      </select> -->
    <!-- <ng-container *ngIf="submitted && imageUploadForm_v.subadminid.errors">
        <p
          class="error-message-repair"
          *ngIf="imageUploadForm_v.subadminid.errors.required"
        >
          subadminid is required!
        </p>
      </ng-container>
      <br /> -->
    <!-- <input
        type="text"
        class="form-control"
        placeholder="Remark"
        formControlName="remark"
      /> -->
    <!-- <ng-container *ngIf="submitted && imageUploadForm_v.remark.errors">
        <p
          class="error-message-repair"
          *ngIf="imageUploadForm_v.remark.errors.required"
        >
          remark is required!
        </p>
      </ng-container>
      <br /> -->
    <!-- <div class="modal-footer">
        <button class="btn btn-success" (click)="verify_review_token()">
          Save
        </button>
      </div> -->

  </div>
  <!-- <div class="modal-footer">
    <button
      type="button"
      class="btn btn-light"
      (click)="modal.close('Close click')"
    >
      Close
    </button>
  </div> -->
</ng-template>